import { gql } from "@apollo/client";

export const getCurrentStoreDetails = gql`
  query {
    storeMe {
      _id
      code
      name
      slug
      logo {
        fileUrl
        _id
      }
      payoutDetails {
        payoutMethod
        bankName
        bankBranch
        bankAccountType
        bankAccountName
        bankAccountNumber
        mobileWalletType
        mobileWalletName
        mobileWalletNumber
      }
      banner {
        _id
        fileUrl
      }
      tagline
      description
      email
      phone
      address
      countries {
        name
        _id
        flag
      }
      regions {
        name
        _id
      }
      cities {
        _id
        name
      }
      package {
        _id
        code
        name
        description
        features
        price
        priority
        createdAt
      }
      status
      createdAt
    }
  }
`;
